import React from 'react';
import { PageHeader, CTASmall } from '../components/PageBits';
import { ASSET } from '../mock/data';
import { GraduationCap, Heart, Users, Palette, Globe2, Shield } from 'lucide-react';

const roadmapThemes = [
  { icon: GraduationCap, title: 'Education', desc: 'Expand support for students and create more pathways for learning.' },
  { icon: Heart, title: "Women's Empowerment", desc: 'Build stronger platforms for leadership, wellbeing, enterprise, and recognition.' },
  { icon: Users, title: 'Youth Leadership', desc: 'Develop young volunteers into confident community leaders.' },
  { icon: Palette, title: 'Cultural Development', desc: 'Preserve heritage through events, gatherings, and creative expression.' },
  { icon: Shield, title: 'Community Welfare', desc: 'Strengthen support systems for families and individuals facing hardship.' },
  { icon: Globe2, title: 'Global Connection', desc: 'Bring REFOCC members and well-wishers together across regions.' },
];

const VisionRefocc = () => (
  <>
    <PageHeader kicker="Vision REFOCC" title="A roadmap for stronger" accent="communities and lasting impact." intro="Vision REFOCC is the organization's forward-looking plan for deeper community engagement, stronger programmes, and wider participation. It is rooted in the belief that meaningful change requires continuity, planning, and shared ownership." />
    <section className="py-8"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"><img src={`${ASSET}/community-02.jpg`} alt="Vision REFOCC" className="w-full rounded-[2rem] aspect-[16/7] object-cover"/></div></section>

    {/* Roadmap Themes */}
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-serif text-3xl md:text-4xl text-refocc-dark text-center mb-12">Roadmap Themes</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {roadmapThemes.map(r => (
            <div key={r.title} className="flex gap-5 bg-white rounded-2xl p-6 border border-refocc-dark/10 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 rounded-full bg-refocc-orange/15 text-refocc-orange flex items-center justify-center shrink-0"><r.icon size={20}/></div>
              <div>
                <h3 className="font-serif text-xl text-refocc-dark">{r.title}</h3>
                <p className="text-sm text-refocc-dark/65 mt-1.5 leading-relaxed">{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Future Direction */}
    <section className="py-16 bg-refocc-cream">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-serif text-3xl md:text-4xl text-refocc-dark mb-5">Future Direction</h2>
        <p className="text-refocc-dark/70 mb-8 leading-relaxed max-w-2xl mx-auto">REFOCC aims to grow with clarity and care — expanding its reach while staying close to the people and values that shaped its beginning.</p>
        <CTASmall label="Partner with us" />
      </div>
    </section>
  </>
);

export default VisionRefocc;
